import { render, staticRenderFns } from "./sceen3D.vue?vue&type=template&id=0017c1c0&scoped=true&"
import script from "./sceen3D.vue?vue&type=script&lang=js&"
export * from "./sceen3D.vue?vue&type=script&lang=js&"
import style0 from "./sceen3D.vue?vue&type=style&index=0&id=0017c1c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0017c1c0",
  null
  
)

export default component.exports